import React, { useContext, useState } from 'react';

const SelectionContext = React.createContext();

export function useSelectionContext() {
    return useContext(SelectionContext);
}

const SelectionProvider = ({ selectionList, children }) => {
    const [selection, setSelection] = useState(selectionList[0].topic);

    const handleSelectionClick = (itemSelected) => {
        setSelection(itemSelected);
    };

    const isItemSelected = (itemSelected) => {
        return selection === itemSelected;
    };

    return (
        <>
            <SelectionContext.Provider
                value={{
                    isItemSelected: isItemSelected,
                    selectionList: selectionList,
                    handleSelectionClick: handleSelectionClick,
                }}
            >
                {children}
            </SelectionContext.Provider>
        </>
    );
};

export default SelectionProvider;
